// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import React, { useContext } from "react";

// Custom Contexts
import { UserContext } from "../../Contexts";



// ----------------------------------------------------------------------------
//   Component
// ----------------------------------------------------------------------------


/**
 * If `condition` is true, render the children;
 * otherwise, render the `fallback`, or nothing if none provided.
 */
export function RenderIf({ condition, children, fallback = null }) {
    return ( condition ) ? <>{ children }</> : fallback
}


/**
 * If `condition` is true, render the first child;
 * otherwise, render the second child.
 */
export function RenderIfElse({ condition, children }) {

  // Validate children
  if (!children.length == 2) {
    throw new Error();
  }

  // Choose
  return ( condition ) ? children[0] : children[1]
}


/**
 * RenderIf component that checks user's role
 */
export function RenderIfAdmin({ children, fallback = null }) {

  // Check user's role
  const { userData } = useContext( UserContext );
  const allowAdminFeatures = userData?.value?.role === 'admin';

  // Return the wrapped component
  return (
    <RenderIf condition={ allowAdminFeatures } fallback={ fallback }>{ children }</RenderIf>
  )
}



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default RenderIf;
